export enum DepartmentEn {
  hr = 19 // Bộ phận hr
}
